import { COLORS } from "~/src/styles/config.style";
import styled from "styled-components";
import { RotaBox, RotaTable } from "@teamrota/rota-design";

export const SubpagesWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin: 8px 32px;
`;

export const SubpageBox = styled(RotaBox)<{ isActive: boolean }>`
  cursor: pointer;
  padding: 0px;
  overflow: hidden;

  background-color: ${({ isActive }) =>
    isActive ? COLORS.WHITE : COLORS.NEAR_WHITE};
`;

export const SubpageTitle = styled.div<{ isActive: boolean }>`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;

  color: ${({ isActive }) => (isActive ? COLORS.MAIN_ORANGE : COLORS.BLACK)};
`;

export const SubpageContentWrapper = styled.div`
  padding: 16px;
`;

export const FilterSelect = styled.select`
  height: 36px;
  border: 1px solid ${COLORS.CLOUDY_BLUE};
  border-radius: 8px;
  padding: 0 10px;
  background: ${COLORS.WHITE};
  color: ${COLORS.DARK_GREY};
  font-size: 13px;
`;

export const FilterTextInput = styled.input`
  height: 36px;
  border: 1px solid ${COLORS.CLOUDY_BLUE};
  border-radius: 8px;
  padding: 0 10px;
  background: ${COLORS.WHITE};
  color: ${COLORS.DARK_GREY};
  font-size: 13px;
  width: 100%;
`;

export const FilterLinks = styled.div`
  width: 87vw;
  display: block;
  padding: 0 10px;
  font-weight: 600;

  a {
    padding: 0 12px;
  }
`;

export const FilterGrid = styled.div`
  width: 87vw;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-bottom: 16px;
`;

export const FilterGridRow = styled.div<{ colWidths: string[] }>`
  width: 87vw;
  display: flex;
  align-items: center;

  ${({ colWidths }) =>
    colWidths.map(
      (width, index) => `
        & > div:nth-child(${index + 1}) {
          flex: 0 0 ${width};
          max-width: ${width};
        }
      `,
    )}
`;

export const FilterSlot = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 4px;

  & > select,
  & > input {
    width: 100%;
  }
`;

export const CalendarWrapper = styled.div`
  text-align: center;

  .react-datepicker-popper {
    z-index: 5000;
  }
`;

export const SplitFilterSlot = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  gap: 8px;

  & > select,
  & > input {
    width: 100%;
    min-width: 0;
  }
`;

export const CheckboxLabel = styled.label`
  min-height: 36px;
  display: inline-block;
  vertical-align: middle;
  padding: 12px 12px;
  font-size: 13px;
  color: ${COLORS.DARK_GREY};
  user-select: none;

  input {
    width: 20px;
    margin-right: 5px;
  }
`;

export const RefreshButton = styled.button`
  margin-left: auto;
  width: 36px;
  height: 36px;
  border: 1px solid ${COLORS.CLOUDY_BLUE};
  border-radius: 8px;
  background: ${COLORS.WHITE};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const FooterControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 12px;
  row-gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
`;

export const PaginationSlot = styled.div`
  display: flex;
  align-items: center;
`;

export const OrderBySelect = styled(FilterSelect)`
  min-width: 160px;
`;

export const FooterLabel = styled.span`
  font-size: 13px;
  line-height: 36px;
  color: ${COLORS.DARK_GREY};
  font-weight: 600;
`;

export const FiltersRow = styled.div<{ colWidths: string[] }>`
  width: 87vw;
  display: flex;

  align-items: flex-end;
  margin-bottom: 16px;
  flex-wrap: wrap;

  & .chip-wrapper {
    max-width: none;
  }

  & > select,
  & > input {
    margin-left: 4px;
    margin-right: 4px;
  }

  ${({ colWidths }) =>
    colWidths.map(
      (width, index) => `
        & > select:nth-child(${index + 1}),
        & > input:nth-child(${index + 1}) {
          width: calc(${width} - 8px);
        }
      `,
    )}
`;

export const ScrollableTable = styled(RotaTable)<{ colWidths: string[] }>`
  width: 87vw;

  & > thead,
  & > tbody > tr {
    display: table;
    table-layout: fixed;
  }

  & > thead,
  & > tbody > tr {
    width: 87vw;
  }

  & > tbody {
    display: block;
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  ${({ colWidths }) =>
    colWidths.map(
      (width, index) => `
        & > thead > tr > th:nth-child(${index + 1}),
        & > tbody > tr > td:nth-child(${index + 1}) {
          width: ${width};
        }
      `,
    )}
`;

export const InnerTable = styled.table<{ reason?: boolean }>`
  width: 100%;

  border: 1px solid ${COLORS.MAIN_ORANGE};
  border-radius: 10px;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;

  margin: 4px 0 4px 0;
  
  & > tbody > tr > td {
    padding: 4px;
    margin: 0;
  }

  & > tbody > tr > td:first-child {
    color: ${COLORS.WHITE};
    background-color: ${({ reason }) =>
      reason ? COLORS.RED : COLORS.MAIN_ORANGE};
  }

  & > tbody > tr > td:first-child > a {
    color: ${COLORS.WHITE};
  }
}`;
